import styled, { css } from 'styled-components';

export const Container = styled.div<{}>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const PaginatorContainer = styled.div<{}>`
  align-items: center;
  display: flex;
  padding: 0 10px;
`;

export const PageButtonContainer = styled.div<{}>`
  padding-left: 5px;
  padding-right: 5px;
`;

export const PageButton = styled.div<{ page: number; currentPage: number }>`
  align-items: center;
  border-radius: 50%;
  color: ${({ theme }) => theme.gray80};
  display: flex;
  font-size: 14px;
  height: 24px;
  justify-content: center;
  user-select: none;
  width: 24px;

  ${({ page, currentPage }) =>
    page - 1 === currentPage
      ? css`
          background-color: ${({ theme }) => theme.paginator.active};
          color: ${({ theme }) => theme.white};
          cursor: default;
        `
      : css`
          cursor: pointer;
          &:hover {
            background-color: ${({ theme }) => theme.paginator.hover};
          }
        `}
`;

export const Dots = styled.div<{}>`
  cursor: default;
  user-select: none;
  color: ${({ theme }) => theme.gray80};
`;
